import React from 'react';

import _ from 'lodash';

import Modal from 'antd/lib/modal/Modal';
import { ConfigProvider, DatePicker } from 'antd';
import locale from 'antd/lib/locale/ru_RU';
import Table, { ColumnsType } from 'antd/lib/table';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';

import User from 'cvat-core/src/user';

import './styles.scss';

dayjs.locale('ru');

const { RangePicker } = DatePicker;

export interface MetricsType {
    key: string;
    user?: User;
    boxes?: number;
    [key: string]: any;
}

interface SettingsModalProps {
    visible: boolean;
    metrics: MetricsType[];
    onClose(): void;
    loadTableDataSpin: boolean;
    changeRangeTime(rangeTime: string[]): void;
    instansName: string;
}

function MetricsModal(props: SettingsModalProps): JSX.Element {
    const { visible, onClose, metrics, loadTableDataSpin, changeRangeTime, instansName } = props;

    const columns: ColumnsType<MetricsType> = [
        {
            title: 'Разметчики',
            dataIndex: 'worker',
            key: 'worker',
            render: (_, row) => <>{row.user?.username}</>,
        },
        {
            title: 'Всего боксов',
            dataIndex: 'boxes',
            key: 'boxes',
            render: (_, row) => <>{row.boxes}</>,
        },
    ]

    const onChangeRange = (values: any) => {
        const startTimestamp = values[0] ? `${values[0].valueOf()}` : '';
        const endTimestamp = values[1] ? `${values[1].valueOf()}` : '';

        changeRangeTime([startTimestamp, endTimestamp]);
    };

    const convertToTableFormat = (inputData: MetricsType[]) => {
        const rows = [];
        for (const key in inputData[0]) {
            if (key === 'key') continue;

            let newKey = '';

            switch (key) {
                case 'user':
                    newKey = 'Разметчик';
                    break;
                case 'boxes':
                    newKey = 'Всего боксов';
                    break;
                default:
                    newKey = key;
                    break;
            }

            rows.push({
                key: newKey,
                value: key === 'user' ? inputData[0][key]?.username : inputData[0][key],
            });
        }
        return rows;
    };

    const vericalColumns = [
        {
            title: 'Название',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: 'Значение',
            dataIndex: 'value',
            key: 'value',
        },
    ];

    const metricsVerticalTable = convertToTableFormat(metrics);

    return (
        <Modal
            title='Метрики'
            open={visible}
            onCancel={onClose}
            width={800}
            className='cvat-settings-modal'
            footer={null}
        >
            <div className='cvat-settings-tabs'>
                <ConfigProvider locale={locale}>
                    <RangePicker onChange={onChangeRange} format="YYYY-MM-DD" placeholder={['Начало', 'Конец']} allowClear />
                </ConfigProvider>

                {instansName !== 'obj_id' ? (
                    <Table
                        className='cvat-task-jobs-table'
                        rowClassName={() => 'cvat-task-jobs-table-row'}
                        columns={columns}
                        dataSource={metrics}
                        size='small'
                        loading={{ spinning: loadTableDataSpin, tip: 'Загрузка данных...', size: 'small' }}
                        pagination={false}
                    />
                ) : (
                    <Table
                        className='cvat-task-jobs-table'
                        rowClassName={() => 'cvat-task-jobs-table-row'}
                        columns={vericalColumns}
                        dataSource={metricsVerticalTable}
                        size='small'
                        loading={{ spinning: loadTableDataSpin, tip: 'Загрузка данных...', size: 'small' }}
                        pagination={false}
                        />
                    )
                }
            </div>
        </Modal>
    );
}

export default React.memo(MetricsModal);
